import {Component, AfterViewInit, OnInit} from "@angular/core";
import {StripeService} from "../../../services/data/stripe.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {Transaction} from "../../../model/bill/transaction";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";

declare const Stripe: any;

@Component({
  selector: 'stripe-callback',
  template: require('./stripe-callback.component.html'),
  styles: [
    require('./stripe-callback.component.scss')
  ]
})
export class StripeCallbackComponent implements AfterViewInit, OnInit {

  intentId: string;

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(
      params => {
        this.intentId = params['intentId'];

        if(this.intentId!=null) {
          this.getTransaction();
        }
      }
    );
  }

  stripe: any;
  elements: any;
  card: any;

  completed: boolean = false;
  success: boolean = false;
  failed: boolean = false;

  ngAfterViewInit(): void {
  }

  constructor(private stripeService: StripeService, private activatedRoute: ActivatedRoute,
              private currentBusiness: CurrentBusinessService) {

  }

  getTransaction() {
    this.stripeService.getTransaction(this.intentId, this.currentBusiness.getBusiness().id).subscribe(
      transaction => this.handleTransaction(transaction)
    );
  }

  handleTransaction(transaction: Transaction) {
    if(transaction.status=='COMPLETED') {
      this.completed = true;
      this.success = true;
      this.currentBusiness.reloadBusiness();
    }
    if(transaction.status=='FAILED' || transaction.status=='CANCELED') {
      this.completed = true;
      this.failed = true;
    }

    if(!this.completed) {
      let that = this;
      setTimeout(function() {
        that.getTransaction();
      }, 10000)
    }
  }


}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/premium/stripe-callback/stripe-callback.component.ts